// admin menu-items
import { EyeOutlined, EditOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";

const icons = {
  EyeOutlined,
  EditOutlined,
  TeamOutlined,
  UserOutlined,
};

const admin = {
  id: "admin",
  title: "Admin",
  type: "group",
  hidden: true,
  children: [
    {
      id: "admin-users",
      title: "Users",
      type: "collapse",
      url: "/admin/users",
      icon: icons.TeamOutlined,
      hidden: true, // Won't show in sidebar but will generate breadcrumbs
      children: [
        {
          id: "admin-edit-user",
          title: "Edit User",
          type: "item",
          url: "/admin/editUser",
          icon: icons.EditOutlined,
          hidden: true,
        },
        {
          id: "admin-show-user",
          title: "User Data",
          type: "item",
          url: "/admin/showUser",
          icon: icons.EyeOutlined,
          hidden: true,
        },
      ],
    },
    {
      id: "admin-edit-host",
      title: "Edit Host",
      type: "item",
      url: "/admin/editHost",
      icon: icons.EditOutlined,
      hidden: true,
    },
    {
      id: "admin-show-host",
      title: "Show Host",
      type: "item",
      url: "/admin/showHost",
      icon: icons.EyeOutlined,
      hidden: true,
    },
  ],
};

export default admin;
